import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Button.module.css';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost';
export type ButtonSize = 'default' | 'large';

interface ButtonProps {
  children: React.ReactNode;
  variant?: ButtonVariant;
  size?: ButtonSize;
  href?: string;
  to?: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'default',
  href,
  to,
  onClick,
  type = 'button',
  className = '',
  disabled = false,
}) => {
  const classNames = [
    styles.btn,
    styles[variant],
    size === 'large' ? styles.large : '',
    className,
  ].filter(Boolean).join(' ');

  // External link
  if (href) {
    return (
      <a href={href} className={classNames}>
        {children}
      </a>
    );
  }

  // Internal link (React Router)
  if (to) {
    return (
      <Link to={to} className={classNames}>
        {children}
      </Link>
    );
  }

  // Button element
  return (
    <button 
      type={type} 
      onClick={onClick} 
      className={classNames}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
